import { getCurrentLanguageCode, getLocalStorage } from "../../utils/helpers";

import {
  LANGUAGE_EN_US_CODE,
  PELICAN_CHECKOUT_COOKIES_CA,
  PELICAN_CHECKOUT_COOKIES_US,
} from "../../constants/AppConstants";
import {
  CREATE_CHECKOUT,
  GET_SHIPPING_RATES,
  GETTING_SHIPPING_RATES_FAILURE,
  GETTING_SHIPPING_RATES_SUCCESS,
  IS_GETTING_SHIPPING_RATES,
  SET_CHECKOUT,
  SET_CHECKOUT_ID,
  UPDATE_CHECKOUT,
} from "../../constants/ActionTypes";
const currentLanguage = getCurrentLanguageCode();
const cookieName =
  currentLanguage === LANGUAGE_EN_US_CODE
    ? PELICAN_CHECKOUT_COOKIES_US
    : PELICAN_CHECKOUT_COOKIES_CA;
const INIT_STATE = {
  checkout: {},
  checkoutId: getLocalStorage(cookieName, null),
  shippingRates: [],
  checkoutErrors: {
    shippingAddress: null,
    shippingMethod: null,
    billingAddress: null,
  },
  isGettingShippingRates: false,
  gettingShippingRateError: null,
  updateContactEmailError: null,
};

/**
 * checkout reducer
 * @param state
 * @param action
 * @returns {{checkout}|{checkout: {}}}
 */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CHECKOUT_ID: {
      return {
        ...state,
        checkoutId: action.payload,
      };
    }
    case SET_CHECKOUT: {
      return {
        ...state,
        checkout: action.payload,
        checkoutId: action.payload?.id,
      };
    }
    case CREATE_CHECKOUT: {
      return {
        ...state,
        checkout: action.payload,
        checkoutId: action.payload?.id,
      };
    }
    case UPDATE_CHECKOUT: {
      return {
        ...state,
        checkout: action.payload,
        checkoutId: action.payload?.id,
      };
    }
    case GET_SHIPPING_RATES: {
      return {
        ...state,
        shippingRates: action.payload,
      };
    }

    case IS_GETTING_SHIPPING_RATES: {
      return {
        ...state,
        isGettingShippingRates: true,
      };
    }

    case GETTING_SHIPPING_RATES_SUCCESS: {
      return {
        ...state,
        isGettingShippingRates: false,
      };
    }

    case GETTING_SHIPPING_RATES_FAILURE: {
      return {
        ...state,
        isGettingShippingRates: false,
        gettingShippingRateError: action.payload,
      };
    }

    default:
      return state;
  }
};
